import { render, staticRenderFns } from "./SelectSizing.vue?vue&type=template&id=38a92165"
import script from "./SelectSizing.vue?vue&type=script&lang=js"
export * from "./SelectSizing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports